import { render, staticRenderFns } from "./FrontNoticeItem.vue?vue&type=template&id=2dedb66c"
import script from "./FrontNoticeItem.vue?vue&type=script&lang=js"
export * from "./FrontNoticeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports